import type { Components, Theme } from "@mui/material";

export const cardTheme: Components<Theme>["MuiCard"] = {
  defaultProps: {
    variant: "elevation",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      boxShadow: theme.customShadows.card,
      borderRadius: theme.borderRadius.md,
      variants: [
        {
          // Default elevated card — lifts on hover when interactive.
          props: { variant: "elevation" },
          style: {
            'a&:hover, &[role="button"]:hover': {
              boxShadow: theme.customShadows.cardHover,
            },
          },
        },
        {
          // Bordered card variant for content nested inside another
          // surface — e.g. a table inside a detail popup or dialog.
          props: { variant: "outlined" },
          style: {
            boxShadow: "none",
            border: `1px solid ${theme.palette.divider}`,
            overflow: "hidden",
          },
        },
      ],
    }),
  },
};
